// src/components/PrivateRoute.jsx
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { Spin } from "antd";

export default function PrivateRoute({ children, feature }) {
  const { user, loading } = useAuth();
  const [blockedFeatures, setBlockedFeatures] = useState([]);
  const [featuresLoading, setFeaturesLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) { setFeaturesLoading(false); return; }
    const fetch = async () => {
      try {
        const snap = await getDocs(query(
          collection(db, "contact"),
          where("FirebaseId", "==", user.uid)
        ));
        if (!snap.empty) {
          setBlockedFeatures(snap.docs[0].data().blockedFeatures || []);
        }
      } catch {}
      setFeaturesLoading(false);
    };
    fetch();
  }, [user]);

  if (loading || featuresLoading) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <Spin size="large" />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;

  const isBlocked = feature && (
    blockedFeatures.includes("*") || blockedFeatures.includes(feature)
  );

  if (isBlocked) return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", height: "100vh",
      background: "#f8fafc", gap: 12,
    }}>
      <div style={{ fontSize: 56 }}>🚫</div>
      <div style={{ fontSize: 20, fontWeight: 700, color: "#0f172a" }}>Accès restreint</div>
      <div style={{ fontSize: 13, color: "#64748b", textAlign: "center", maxWidth: 300, lineHeight: 1.7 }}>
        Vous n'avez pas accès à cette fonctionnalité.<br />
        Contactez l'administration WeStudy.
      </div>
      <button onClick={() => window.history.back()} style={{
        marginTop: 8, padding: "10px 24px", borderRadius: 10,
        border: "none", background: "#2563eb", color: "#fff",
        fontSize: 13, fontWeight: 600, cursor: "pointer",
      }}>
        ← Retour
      </button>
    </div>
  );

  return children;
}